<template>
  <div class="header">
    <div class="container">
      <div class="nav">
        <div class="logo">香草终端</div>
        <el-menu
          :default-active="$route.path"
          class="el-menu-demo"
          text-color="#C7D2FF"
          active-text-color="#FFFFFF"
          mode="horizontal"
          @select="goto">
          <el-menu-item v-for="(item, index) in obj.navList" :index="item.path" :key="index">
            <span>{{ item.name }}</span>
          </el-menu-item>
        </el-menu>
      </div>

      <div class="userInfo">
        <el-dropdown class="changeStyle">
            <div><img src="../assets//images/headerIcon01.png" alt=""><p>风格</p></div>
            <template #dropdown>
                <el-dropdown-menu>
                    <el-dropdown-item class="el-dropdown-item" @click="changeStyle('blue')"><div>蓝色</div></el-dropdown-item>
                    <el-dropdown-item class="el-dropdown-item" @click="changeStyle('red')"><div>红色</div></el-dropdown-item>
                    <el-dropdown-item class="el-dropdown-item" @click="changeStyle('black')"><div>黑色</div></el-dropdown-item>
                </el-dropdown-menu>
            </template>
        </el-dropdown>

        <span v-if="obj.userInfo">
          {{obj.userInfo.corp}} | 
        账号：{{obj.userInfo.account}}</span>
        <el-button @click="logout">退出</el-button>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { reactive,onMounted } from "vue"
import { useRouter } from "vue-router";
const router = useRouter();
import { queryUserInfo } from "../api/api"

import {useStore} from 'vuex'
const store= useStore()

let obj = reactive({
  userInfo: '',
  navList: [
    // {name: '资产',path: '/PropertyView'},
    {name: '询价管理',path: '/HomeView'},
    {name: '询价记录',path: '/ManageView'},
    {name: '持仓列表',path: '/HoldList'},
    {name: '历史持仓',path: '/HistoryList'},
    {name: '算法服务',path: '/AlgorithmView'},
  ],
})

function goto(path){  // 切换菜单栏
  router.push({
    path: path
  });
}

onMounted(() => {
  if(window.sessionStorage.getItem('token')){
    toQueryUserInfo(window.sessionStorage.getItem('token'))
  }
})
 // 请求 代理用户 信息接口
function toQueryUserInfo(token){
    queryUserInfo({token: token}).then(data=>{
        // console.log('用户信息',data);
        if(data.data.code == 200){
            obj.userInfo = data.data.data;
            window.sessionStorage.setItem('userInfo',JSON.stringify(data.data.data))
        }
    })
}

function logout(){
  // 清空token
  window.sessionStorage.clear()
  store.commit('clearToken')
  // 跳转到登录页
  router.push('/LoginView')

}

/* 全局修改网站颜色风格--定义 */
function changeStyle(style){
  // console.log(style);
  if(style == 'blue'){
    document.documentElement.style.setProperty("--main_color", '#5051F9');
    document.documentElement.style.setProperty("--bg_color", '#F7F7F9');
    document.documentElement.style.setProperty("--bg2_color", '#FFFFFF');
    document.documentElement.style.setProperty("--active_color", '#FFFFFF');
    document.documentElement.style.setProperty("--button_color", '#5051F9');
    document.documentElement.style.setProperty("--font_color1", '#333333');
    document.documentElement.style.setProperty("--font_color2", '#333333');
    document.documentElement.style.setProperty("--buttonBg_color", '#FFFFFF');
    document.documentElement.style.setProperty("--buttonBorder_color", '#EAEAEB');
    document.documentElement.style.setProperty("--table_color1", '#F2F2F2');
    document.documentElement.style.setProperty("--table_color2", '#FFFFFF');
    document.documentElement.style.setProperty("--table_color3", '#F2F2F2');
    document.documentElement.style.setProperty("--table_color4", '#FFFFFF');
    document.documentElement.style.setProperty("--table_font_color1", '#7889A0');
    document.documentElement.style.setProperty("--table_font_color2", '#333333');
    document.documentElement.style.setProperty("--table_font_color3", '#7889A0');
    document.documentElement.style.setProperty("--table_font_color4", '#333333');
    document.documentElement.style.setProperty("--table_bg_color", '#F8FCFF');
  }else if(style == 'red'){
    document.documentElement.style.setProperty("--main_color", '#E6322E');
    document.documentElement.style.setProperty("--bg_color", '#F7F7F9');
    document.documentElement.style.setProperty("--bg2_color", '#FFFFFF');
    document.documentElement.style.setProperty("--active_color", '#FFFFFF');
    document.documentElement.style.setProperty("--button_color", '#E6322E');
    document.documentElement.style.setProperty("--font_color1", '#333333');
    document.documentElement.style.setProperty("--font_color2", '#333333');
    document.documentElement.style.setProperty("--buttonBg_color", '#FFFFFF');
    document.documentElement.style.setProperty("--buttonBorder_color", '#EAEAEB');
    document.documentElement.style.setProperty("--table_color1", '#F2F2F2');
    document.documentElement.style.setProperty("--table_color2", '#FFFFFF');
    document.documentElement.style.setProperty("--table_color3", '#F2F2F2');
    document.documentElement.style.setProperty("--table_color4", '#FFFFFF');
    document.documentElement.style.setProperty("--table_font_color1", '#7889A0');
    document.documentElement.style.setProperty("--table_font_color2", '#333333');
    document.documentElement.style.setProperty("--table_font_color3", '#7889A0');
    document.documentElement.style.setProperty("--table_font_color4", '#333333');
    document.documentElement.style.setProperty("--table_bg_color", '#F8FCFF');
  }else if(style == 'black'){
    document.documentElement.style.setProperty("--main_color", '#1E2538');
    document.documentElement.style.setProperty("--bg_color", '#252B41');
    document.documentElement.style.setProperty("--bg2_color", '#1E2538');
    document.documentElement.style.setProperty("--active_color", '#5051F9');
    document.documentElement.style.setProperty("--button_color", '#5051F9');
    document.documentElement.style.setProperty("--font_color1", '#CECECE');
    document.documentElement.style.setProperty("--font_color2", '#FFFFFF');
    document.documentElement.style.setProperty("--buttonBg_color", '#2C344B');
    document.documentElement.style.setProperty("--buttonBorder_color", '#3F4867');
    document.documentElement.style.setProperty("--table_color1", '#2C344B');
    document.documentElement.style.setProperty("--table_color2", '#2C344B');
    document.documentElement.style.setProperty("--table_color3", '#6E7794');
    document.documentElement.style.setProperty("--table_color4", '#3F4867');
    document.documentElement.style.setProperty("--table_font_color1", '#CECECE');
    document.documentElement.style.setProperty("--table_font_color2", '#FFFFFF');
    document.documentElement.style.setProperty("--table_font_color3", '#2C344B');
    document.documentElement.style.setProperty("--table_font_color4", '#CECECE');
    document.documentElement.style.setProperty("--table_bg_color", '#4E587B');
  }
}

</script>

<style lang="scss" scoped>
  .header{height: 60px;line-height: 60px;background: var(--main_color);}
  .header .container{display: flex;align-content: center;justify-content: space-between;}
  .header .container .nav{display: flex;align-items: center;}
  .header .logo{font-size: 20px;font-family: 'Noto Sans SC, Noto Sans SC';font-weight: bold;color: #FFFFFF;line-height: 60px;}
  .header ul{display: flex;align-items: center;margin: 0 20px;min-width: 700px;}
  .header ul li{height: 56px;cursor: pointer;padding: 0 20px;padding-top: 2px;}
  .header ul li span{font-size: 14px;font-family: 'Noto Sans SC, Noto Sans SC';font-weight: 500;color: rgba(255,255,255,0.8);line-height: 56px;border-bottom: 2px solid transparent;}
  .header ul li.is-active{background: transparent!important;}
  .header ul li.is-active span{font-size: 16px;color: var(--active_color);border-bottom: 2px solid var(--active_color);}
  .header .userInfo{display: flex;align-items: center;}
  .header .userInfo span{font-size: 16px;font-family: 'Noto Sans SC, Noto Sans SC';font-weight: 500;color: #FFFFFF;line-height: 60px;margin-right: 20px;}
  .header .userInfo .el-button{height: 28px;line-height: 28px;background: #FFFFFF;border-radius: 8px 8px 8px 8px;font-size: 14px;font-family: 'Noto Sans SC, Noto Sans SC';font-weight: 500;color: var(--button_color);border: none;}
  
  .el-menu{background: transparent;}
  .el-menu-item:hover,.el-menu-item:checked{
    background-color: transparent!important;
  }
  .el-menu-item,.el-menu-item.is-active,.el-menu--horizontal.el-menu{
    border-bottom: none!important;
  }
  .el-menu--horizontal .el-menu-item:not(.is-disabled):focus, .el-menu--horizontal .el-menu-item:not(.is-disabled):hover{background: transparent;}

  .changeStyle{width: 80px;margin-right: 20px;}
  .changeStyle div{width: 64px;height: 36px;position: relative;display: flex;justify-content: flex-start;align-items: center;padding: 0 8px;}
  .changeStyle div img{width: 15px;height: 11px;margin-right: 3px;}
  .changeStyle div p{font-family: 'Noto Sans SC, Noto Sans SC';font-weight: 400;font-size: 14px;color: #FFFFFF;line-height: 60px;margin: 0;}
  .changeStyle div::after{content: '';width: 0;height: 0;border-left: 6px solid transparent;border-right: 6px solid transparent;border-top: 6px solid #fff;position: absolute;right: 8px;top: 15px;}
  .el-dropdown-item div{position: relative;padding-left: 24px;}
  .el-dropdown-item:nth-child(1) div::before{content: '';width: 16px;height: 16px;background: #5051F9;border-radius: 50%;position: absolute;left: 0; top: 3px;}
  .el-dropdown-item:nth-child(2) div::before{content: '';width: 16px;height: 16px;background: #E6322E;border-radius: 50%;position: absolute;left: 0; top: 3px;}
  .el-dropdown-item:nth-child(3) div::before{content: '';width: 16px;height: 16px;background: #33363A;border-radius: 50%;position: absolute;left: 0; top: 3px;}
  :global(.el-dropdown-item) {
      color: #333333!important;
  }
  :global(.el-dropdown-item:not(.is-disabled):hover) {
      background: #F4F5F7!important;
  }
</style>
